import React from "react";
import { Typography, Box } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts";

interface GaugeCardProps {
  visitors: number;
  goal: number;
  percentage: number | string;
  label?: string;
}

const GaugeCard: React.FC<GaugeCardProps> = ({
  visitors,
  goal,
  label,
  percentage,
}) => {
  const safeVisitors = visitors || 0;
  const safeGoal = goal || 1;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px 0px 5px 0px",
        }}
      >
        <Gauge
          value={visitors}
          valueMax={safeGoal}
          valueMin={0}
          width={270}
          height={130}
          startAngle={-90}
          endAngle={90}
          text=""
          sx={{
            width: "max-content",
            [`& .${gaugeClasses.referenceArc}`]: {
              fill: "var(--pale-gray)",
            },
            [`& .${gaugeClasses.valueArc}`]: {
              fill: "var( --vibrant-green)",
            },
          }}
        />
        {/* Centered Text */}
        <Box
          sx={{
            position: "absolute",
            textAlign: "center",
            top: "64%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            {label}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {safeVisitors.toLocaleString()}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" textAlign={"center"}>
          {percentage}% of {safeGoal.toLocaleString()}
        </Typography>
      </Box>
    </Box>
  );
};

export default GaugeCard;
